export enum UserMoodFrequency {
	NONE = 'NONE', // NONE
	DAY = 'DAY', // DAY
	WEEK = 'WEEK', // WEEK
	BIWEEKLY = 'BIWEEKLY', // BIWEEKLY
}
